import OnlineOrderComponent from "../../components/admin/onlineOrders/OnlineOrderComponent";
import OnlineOrderListComponent from "../../components/admin/onlineOrders/OnlineOrderListComponent";
import OnlineOrderShowComponent from "../../components/admin/onlineOrders/OnlineOrderShowComponent";

export default [
    {
        path: '/admin/pedidos-online',
        component: OnlineOrderComponent,
        name: 'admin.order',
        redirect: {name: 'admin.order.list'},
        meta: {
            isFrontend: false,
            auth: true,
            permissionUrl: 'online-orders',
            breadcrumb: 'online_orders'
        },
        children: [
            {
                path: '',
                component: OnlineOrderListComponent,
                name: 'admin.order.list',
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: 'online-orders',
                    breadcrumb: ''
                },
            },
            {
                path: "ver/:id",
                component: OnlineOrderShowComponent,
                name: "admin.order.show",
                meta: {
                    isFrontend: false,
                    auth: true,
                    permissionUrl: "online-orders",
                    breadcrumb: "view",
                },
            }
        ]
    }
]
